import { HttpAxiosRequest } from 'src/http/httpAxiosBase';
import { z } from 'src/lib';
import { BaseResponse } from 'src/types';
import { SistemaTipo } from "../../../../../types/enum/enum";
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme";
import {
    OperacionLEPEmisorInsert,
    OperacionLEPEmisorUpdate,
    OperacionLEPEmisorView,
    OperacionLEPInsert,
    schemaOperacionLEPEmisorInsert,
    schemaOperacionLEPEmisorView,
    schemaOperacionLEPInsert
} from '../types/dto';
import { OperacionLEP, schemaOperacionLEP } from '../types/types';

export const getEndpoint = (url = '') => `operaciones/lep${url}`;

export const HttpLEP = {
    get: (idOperacion: number): Promise<OperacionLEP> => {
        return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionLEP.safeParse(response);

                if (!parsed.success) {
                    console.error('Validation Error (HttpLEP.get):', parsed.error.issues);

                    return Promise.reject(new Error('Validation error.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Network Error (HttpLEP.get):', error);

                return Promise.reject(new Error('Error obteniendo operación.'));
            });
    },

    post: (operacion: OperacionLEPInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionLEPInsert.safeParse(operacion);

        if (!parsed.success) {
            console.error('Validation Error (HttpLEP.post):', parsed.error.issues);

            return Promise.reject(new Error('Validation error.'));
        }

        return HttpAxiosRequest.post(getEndpoint(), parsed.data)
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Network Error (HttpLEP.post):', error);

                return Promise.reject(new Error('Error insertando operación.'));
            });
    },


    getEmisores: (idOperacion: number): Promise<OperacionLEPEmisorView[]> => {
        const endpoint = getEndpoint(`/${idOperacion}/emisores`);

        return HttpAxiosRequest.get(endpoint)
            .then(response => {
                const schemaList = z.array(schemaOperacionLEPEmisorView);

                const parsed = schemaList.safeParse(response);

                if (!parsed.success) {
                    console.error('Validation Error (HttpLEP.getEmisores):', parsed.error.issues);

                    return Promise.reject(new Error('Validation error.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Network Error (HttpLEP.getEmisores):', error);

                return Promise.reject(new Error('Network error.'));
            });
    },

    updateEmisor: (operacion: OperacionLEPEmisorUpdate, idOperacion: number, idEmisor: number): Promise<BaseResponse> => {
        const parsed = schemaOperacionLEPEmisorInsert.safeParse(operacion);

        if (!parsed.success) {
            console.error('Validation Error (HttpLEP.post):', parsed.error.issues);

            return Promise.reject(new Error('Validation error.'));
        }

        return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}/emisores/${idEmisor}`), parsed.data)
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Network Error (HttpLEP.post):', error);

                return Promise.reject(new Error('Network error.'));
            });
    },

    insertEmisores: (idOperacion: number, emisores: OperacionLEPEmisorInsert[]): Promise<BaseResponse> => {
        const schemaList = z.array(schemaOperacionLEPEmisorInsert);
        const parsed = schemaList.safeParse(emisores);

        if (!parsed.success) {
            console.error('Validation Error (HttpLEP.insertEmisores):', parsed.error.issues);
            
            return Promise.reject(new Error('Validation error.'));
        }

        const endpoint = getEndpoint(`/${idOperacion}/emisores`);

        return HttpAxiosRequest.post(endpoint, parsed.data)
            .then(response => Promise.resolve(response))
            .catch(error => {
                console.error('Network Error (HttpLEP.insertEmisores):', error);

                return Promise.reject(new Error('Network error.'));
            });
    },

    deleteEmisor: (idOperacion: number, idEmisor: number): Promise<BaseResponse> => {
        const endpoint = getEndpoint(`/${idOperacion}/emisores/${idEmisor}`);

        return HttpAxiosRequest.delete(endpoint)
            .then(response => Promise.resolve(response))
            .catch(error => {
                console.error('Network Error (HttpLEP.deleteEmisor):', error);

                return Promise.reject(new Error('Network error.'));
            });
    },

    descargarInforme: (idOperacion: number): Promise<any> =>
        HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.LEP),

} as const;
